import { AttachFileRounded } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { isNil } from "lodash";
import { useMemo, useState } from "react";
import LoanFilePreview from "../../../screens/LoanDrilldownScreen/tabs/LoanDrilldownFilesTab/LoanFilePreview";
import Flx from "../../layout/Flx";
import SideCardModal from "../../modals/SideCardModal";
import { blue } from "@mui/material/colors";

const CellRendererLoanFiles = (params) => {
  const [file, setFile] = useState(null);
  const files = useMemo(() => {
    const paramsfiles = params?.value || [];
    return [...paramsfiles].reverse();
  }, [params?.value]);

  const buttonStyles = useMemo(() => {
    return {
      background: blue[50],
      minWidth: "50px",
      p: 0.4,
      mr: 1,
      borderRadius: "4px",
      justifyContent: "flex-start",
      textTransform: "none",
      "&:hover": {
        background: blue[100],
      },
    };
  }, []);
  return (
    <Flx
      gap={0}
      sx={{
        height: "100%",
        alignItems: "center",
        minWidth: "100px",
        flexWrap: "nowrap",
        overflow: "hidden",
      }}
    >
      {files.map((f) => (
        <Button
          key={f._id}
          startIcon={
            <AttachFileRounded
              className="thin"
              sx={{ mr: -1, fontSize: "14px !important" }}
            />
          }
          variant="text"
          onClick={() => setFile(f)}
          sx={buttonStyles}
        >
          <Box
            component="span"
            sx={{
              display: "inline-block",
              overflow: "hidden",
              whiteSpace: "nowrap",
              pr: 0.5,
              textOverflow: "ellipsis",
            }}
          >
            {f.file_display_name || f.name}
          </Box>
        </Button>
      ))}

      <SideCardModal
        title={file?.file_display_name || "File Preview"}
        show={!isNil(file)}
        onClose={() => setFile(null)}
        suppressBodyPadding
      >
        <LoanFilePreview
          fileObject={file}
          containerId={file?.containerName}
          sx={{ overflowY: "auto" }}
        />
      </SideCardModal>
    </Flx>
  );
};

export default CellRendererLoanFiles;
